export default __webpack_public_path__ + "static/media/tabula-logo-wordmark.75f17688.svg";